const auth = {
  state: {
    isLoggedIn: false,
    userInfo: {},
    token: '',
  },

  mutations: {
    setLoginState(state, payload) {
      state.isLoggedIn = true;
      state.userInfo = payload.userInfo || {};
      state.token = payload.token || '';
      localStorage.setItem('PORTAL_TOKEN', payload.token || '');
      localStorage.setItem('PORTAL_USER_INFO', JSON.stringify(payload.userInfo || {}));
    },

    clearLoginState(state) {
      state.isLoggedIn = false;
      state.userInfo = {};
      state.token = '';
      localStorage.removeItem('PORTAL_TOKEN');
      localStorage.removeItem('PORTAL_USER_INFO');
    },

    restoreLoginState(state) {
      const token = localStorage.getItem('PORTAL_TOKEN');
      const userInfoStr = localStorage.getItem('PORTAL_USER_INFO');
      if (token) {
        state.isLoggedIn = true;
        state.token = token;
        state.userInfo = userInfoStr ? JSON.parse(userInfoStr) : {};
      }
    },
  },

  actions: {
    setLoginState({ commit }, payload) {
      commit('setLoginState', payload);
    },

    clearLoginState({ commit }) {
      commit('clearLoginState');
    },

    restoreLoginState({ commit }) {
      commit('restoreLoginState');
    },
  },
};

export default auth;
